module.exports = __webpack_public_path__ + "fonts/Inter-500-latin56.8e433c0.woff2";